"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmCalendarHeader = void 0;
const classnames_1 = __importDefault(require("classnames"));
const date_fns_1 = require("date-fns");
const react_1 = __importDefault(require("react"));
const SmCalendarHeader = (_a) => {
    var { className, currentMonth, arrows, locale } = _a, props = __rest(_a, ["className", "currentMonth", "arrows", "locale"]);
    const calendarHeaderClassnames = (0, classnames_1.default)('c-calendar__header', className);
    return (react_1.default.createElement("div", Object.assign({}, props, { className: calendarHeaderClassnames }), arrows === null || arrows === void 0 ? void 0 :
        arrows.previous,
        react_1.default.createElement("div", { className: "c-calendar__headerDetails" },
            react_1.default.createElement("span", { className: "month" }, `${(0, date_fns_1.format)(currentMonth, 'MMMM', { locale })}`),
            react_1.default.createElement("span", { className: "year" }, (0, date_fns_1.format)(currentMonth, 'yyyy', { locale }))), arrows === null || arrows === void 0 ? void 0 :
        arrows.next));
};
exports.SmCalendarHeader = SmCalendarHeader;
//# sourceMappingURL=SmCalendarHeader.js.map